const requestURL = url => `https://${process.env.BACKEND_DOMAIN}/api/${url}`

export default requestURL
